import React, { useEffect, useRef, useState } from "react";
import { BrowserRouter as Router, Switch, Route, Link, useNavigate } from 'react-router-dom';
import ImageUploader from '../../commonComponents/Imageuploader';
import Form from 'react-bootstrap/Form';
import moment from "moment";
import {getProfileDetails } from "../../services/apiProfile";
import { editOrganizationDetails } from "../../services/apiOragnizations";
import Datetime from 'react-datetime';
import "react-datetime/css/react-datetime.css";
import { ApiHelper } from "../../helpers/ApiHelper";
import { API } from "../../services/api";
import Validation from "../../commonComponents/Validation";
import DeleteAccount from "./DeleteAccount";
import ResponsePopup from "../../commonComponents/responseSucessPopup";
import EditEmail from "./Editemail";
import { MultiSelect } from "primereact/multiselect";
import { months } from "../../utils/Month";
 const EditOrganization = () => {
    const user = JSON.parse(localStorage.getItem('userData'));
    const navigate = useNavigate()
    const [firstName, setFirstName] = useState('');
    const[membercount,setMemberCount]= useState('');
    const [contactName, setContactName] = useState('');
    const [email, setEmail] = useState('');
    const [zip, setZip] = useState('');
    const [phoneNumber, setphoneNumber] = useState('');
    const [taxId, setTax] = useState('');
    const [website, setwebsite] = useState('');
    const [bio, setBio] = useState('');
    const [foundedDate, setFoundedDate] = useState('');
    const [dateError, setDateError] = useState('');
    const [month, setMonth] = useState('');
    const [day, setDay] = useState('');
    const [year, setYear] = useState('');
    const [location, setLocation] = useState('');
    const [country, setCountry] = useState('');
    const [proImg, setProImg] = useState('');
    const [coverImg, setCoverImg] = useState('');
    const [isCalendarOpen, setIsCalendarOpen] = useState(false);
    const [countryArr, setCountryArr] = useState([]);
    const [profileImgArr, setProfileImgArr] = useState([]);
    const [coverImgArr, setCoverImgArr] = useState([]);
    const [questionArr, setQuestioArr] = useState([]);
    const [orgBasicQuestions, setOrgBasicQuestions] = useState([]);
    const [error, setError] = useState(false);
    const firstNameRef = useRef(null);
    const contactNameRef = useRef(null);
    const foundedDateRef = useRef(null);
    const [isDeleteAccount, setIsDeleteAccount] = useState(false);
    const handleDeleteAccountClose = () => setIsDeleteAccount(false);
    const [isSucess, SetSucess] = useState(false);
    const [ResponseMessage, SetResponseMessage] = useState("");
    const [isEditEmail, setIsEditEmail] = useState(false);
    const handleEditEmailClose = () => setIsEditEmail(false);
    // Add these refs once, before your return (inside EditOrganization component)
const monthRefs = React.useRef({});
const dayRefs = React.useRef({});
const yearRefs = React.useRef({});
const [, forceRender] = React.useState(0); // to refresh view


    useEffect(() => {
        fetchProfileDetails();
        getAllCountry();
    }, [])
    const fetchProfileDetails = async () => {
        const formData = {
            userid: user._id
        }
        let profile = await getProfileDetails(formData);
        let membercount = profile.user?.membersCount ?? ""; 
        setFirstName(profile.user.firstName);
        setContactName(profile.user.contactName);
        setEmail(profile.user.email);
       
        setCountry(profile.user.country);
        setLocation(profile.user.location);
        setZip(profile.user.zipcode);
        setBio(profile.user.bio);
        setphoneNumber(profile.user.phoneNumber);
        setwebsite(profile.user.website);
        setTax(profile.user.taxId);
        setMemberCount(membercount);
        setProImg(profile.user?.profileImage?.url);
        setCoverImg(profile.user?.coverImage?.url);
        setProfileImgArr(profile?.user?.profileImage);
        setCoverImgArr(profile?.user?.coverImage);
        setOrgBasicQuestions(profile?.organizationBasicQuestions)
        if (profile?.user?.foundedDate) {
                const m = moment(profile.user.foundedDate).format('MM');
                const d = moment(profile.user.foundedDate).format('DD');
                const y = moment(profile.user.foundedDate).format('YYYY');
                setMonth(m);
                setDay(d);
                setYear(y);
                setFoundedDate(`${m}/${d}/${y}`);
            }
        
    }
    const getAllCountry = async () => {
        await ApiHelper.post(API.countriesList)
            .then((resData) => {
                setCountryArr(resData.data.data)
            })
            .catch((err) => {
                console.log(err, 'err');
            });
    }
    const handleEmailSuccess = (message, status, email) => {
        if (status === true) {
            setEmail(email)
        }

        SetSucess(true);
        SetResponseMessage(message);
    };

   
    const handleFocus = () => {
        setIsCalendarOpen(true);
    };
    const handleChange = (selectedDate) => {
        setFoundedDate(selectedDate);
        setTimeout(() => {
            setIsCalendarOpen(false);
        }, 100);
    };
    
    useEffect(() => {
  if (month && day && year) {
    const formattedDob = `${month}/${day.padStart(2, '0')}/${year}`;
    
    // Check if this is a valid date
    const parsedDate = new Date(formattedDob);
    const isValid =
      parsedDate instanceof Date &&
      !isNaN(parsedDate) &&
      parsedDate.getMonth() + 1 === parseInt(month) &&
      parsedDate.getDate() === parseInt(day) &&
      parsedDate.getFullYear() === parseInt(year);

    if (isValid) {
      setFoundedDate(formattedDob);
      setDateError(""); // ✅ clear error
    } else {
      setFoundedDate(""); // invalid date
      setDateError("Please enter a valid date"); // ❌ invalid
    }
  } else {
    setFoundedDate("");
    setDateError(""); // no error until all fields filled
  }
}, [month, day, year]);

    useEffect(() => {
        const fetchLocation = async () => {
            if (zip) {
                const result = await getLocationFromZip(zip);
                setLocation(result);
            }
        };

        fetchLocation();
    }, [zip])
    const getLocationFromZip = async (zipCode) => {

        const apiKey = process.env.REACT_APP_ZIP_API
        const url = `https://maps.googleapis.com/maps/api/geocode/json?address=${zipCode}&key=${apiKey}`;

        try {
            const response = await ApiHelper.get(url);

            // 🔒 Prevent accessing undefined when results are empty
            if (!response.data.results || response.data.results.length === 0) {
                console.warn('No results found for zip code:', zipCode);
                return '';
            }

            const components = response.data.results[0].address_components || [];

            const getComponent = (type) =>
                components.find((comp) => comp.types.includes(type))?.long_name || '';

            const streetNumber = getComponent('street_number');
            const route = getComponent('route');
            const city = getComponent('locality');
            const state = getComponent('administrative_area_level_1');
            const postalCode = getComponent('postal_code');
            const country = getComponent('country');

            const formattedAddress = `${city}, ${state}, ${country}`;

            return formattedAddress;
        } catch (error) {
            console.error('Geocoding API error:', error);
            return '';
        }
    };

    useEffect(() => {
       const orgQuestionsArr = (orgBasicQuestions || []).map(q => ({
            questionid: q._id,
            answer: (() => {
                const ans = q.answer?.[0]?.answer;
                if (!ans) return [];
                if (Array.isArray(ans)) {
                    const cleaned = ans.filter(s => s !== "");
                    return cleaned.length ? cleaned : [];
                }
                return ans === "" ? [] : [ans];
            })(),
            weightage: (() => {
                const num = Number(String(q.weightage ?? "").trim());
                return Number.isFinite(num) ? num : 0;
            })()
        }));
        
        setQuestioArr(orgQuestionsArr);
    }, [orgBasicQuestions]);

  
    //  Generic handler for all question types
    const handleIndividualQuestionChange = (questionId, newValue) => {
        setOrgBasicQuestions(prev => {
            const updated = [...prev];
            const idx = updated.findIndex(q => q._id === questionId);
            if (idx !== -1) {
                if (updated[idx].answer?.[0]) {
                    updated[idx].answer[0].answer = Array.isArray(newValue) ? newValue : [newValue];
                } else {
                    updated[idx].answer = [{ answer: Array.isArray(newValue) ? newValue : [newValue] }];
                }
            }
            return updated;
        });
    };
  
    const onUploadComplete = (responseData, type) => {

        if (type === "profile") {
            setProfileImgArr(responseData);
        } else if (type === "cover") {
            setCoverImgArr(responseData); // Force re-render
        }
    };

    const updateProfileDetails = async () => {
        if (dateError) {
            foundedDateRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
            return; // 🔥 immediately stop submission
        }
        const hasInvalidQuestionDate = orgBasicQuestions.some(
        (q) =>
        q.questionControlType === "date" &&
        q?.answer?.[0]?.answer?.[0] === "INVALID_DATE"
    );
    if (hasInvalidQuestionDate) {
        SetResponseMessage("Please correct invalid date entries before saving.");
        SetSucess(true); // show popup gently
        return;
    }
       if (firstName !== "" && contactName !== "" && email !== "" && website !== "" && foundedDate !=="" ) {
       
            setError(false);
            const formData = {
                userid: user._id,
                firstname: firstName,
                contactname: contactName,
                email: email,
                website: website,
                memberscount:membercount,
                foundeddate: moment(foundedDate).format('YYYY-MM-DD'),
                country: country,
                location: country === "681dde46519da80203bdf80f" ? location : "",
                zipcode: country === "681dde46519da80203bdf80f" ? zip : "",
                bio: bio,
                profileimage: profileImgArr,
                coverimage: coverImgArr,
                questions:[],
                phonenumber:phoneNumber,
                taxid:taxId,
                questions: questionArr
            }
          
            let profile = await editOrganizationDetails(formData);
            if (profile.data) {
                localStorage.setItem('userData', JSON.stringify(profile.data));
            }
            fetchProfileDetails()
            if (profile.status) {
                SetSucess(true);
                SetResponseMessage(profile.message);
            }
        }
        else {
            setError(true);
            if (firstName === "") {
                firstNameRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
                firstNameRef.current?.focus();
            } else if (contactName === "") {
                contactNameRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
                contactNameRef.current?.focus();
            } else if (foundedDate === "") {
                foundedDateRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        }
    }

        const handleAcceptNumeric = (event) => {
        const inputValue = event.target.value;
      // Allow empty string or a string containing only digits
        if (inputValue === '' || /^\d+$/.test(inputValue)) {
        setTax(inputValue);
        }
    };
    const panelHeaderTemplate = (options) => {
        const { className, checkboxElement, filterElement, closeElement } = options;
        return (
            <div className={className} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    {checkboxElement}
                    <label style={{ marginLeft: '-7px', fontSize: '13px' }}>Select All</label>
                </div>
                {filterElement}
                {closeElement}
            </div>
        );
    };
   
    const handleAcceptContactName= (event) => {
        const inputValue = event.target.value;
      // Allow empty string or a string containing only letters
        if (inputValue === '' || /^[a-zA-Z ]*$/.test(inputValue)) {
        setContactName(inputValue);
        }
    };

    return (

        <div>
            <div className="hd-breadcums">
                <h3 className="main-heading">Edit Profile</h3>

                
            </div>

            <div className="edit-container">
                <div className="edit profile-wrapper">
                    <div className="edit-field">
                        <label className="edit-profile-label">Profile Image <sup>*</sup></label>
                        <div className="edit-field-group">

                           
                            <div className="form-groups">
                                <div className="profile-img-upload">
                                    <ImageUploader key="profile" type="profile" proImg={proImg} onUploadComplete={onUploadComplete} />
                                   
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="edit-field">
                        <label className="edit-profile-label">Banner Image <sup>*</sup></label>
                        <div className="edit-field-group">

                          
                            <div className="form-groups ml-zer">
                                <div className="profile-img-upload banner-upload">
                                    <ImageUploader key="cover" type="cover" proImg={coverImg} onUploadComplete={onUploadComplete} />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="edit-field">
                        <label className="edit-profile-label">Organization name</label>
                        <div className="edit-field-group">
                            <div className="form-group">
                                <input type="text" ref={firstNameRef} placeholder="First name" className="form-control" onChange={(e) => { setFirstName(e.target.value) }} value={firstName} />
                                {firstName === "" && error ? (
                                    <Validation message={'Please enter first name'} />
                                ) : null}
                            </div>
                        </div>
                    </div>

                    

                    <div className="edit-field">
                        <label className="edit-profile-label">Email Id</label>
                        <div className="edit-field-group">
                            <div className="form-group position-relative">
                                <input type="text" placeholder="Email" className="form-control" value={email} readOnly></input>
                                <button className="leave" onClick={(e) => { e.preventDefault(); setIsEditEmail(true) }}  >Change</button>
                                {email === "" && error ? (
                                    <Validation message={'Please enter email'} />
                                ) : null}
                            </div>
                        </div>
                    </div>
                    <div className="subheading">
                        <h4>About Organization</h4>
                        <span></span>
                    </div>

                   

                    <div className="edit-field">
                        <label className="edit-profile-label">Date of Inception</label>
                        <div className="edit-field-group">
                          
                            <div className="form-group" ref={foundedDateRef}>
                                <div className="dob-splitter mt-3">
                                    <div className="splitter-itm">
                                        <div className="form-input">
                                            
                                            <Form.Select /* className="form-control"  */ aria-label="Default select example" placeholder="Month"
                                                value={month}
                                                onChange={(e) => setMonth(e.target.value)}>
                                                {months.map((m) => (
                                                <option key={m.value} value={m.value}>
                                                    {m.label}
                                                </option>
                                                ))}
                                            </Form.Select>
                                        </div>
                                    </div>
                                    <div className="splitter-itm">
                                        <div className="form-input">
                                            <input type="number" className="form-control"
                                            placeholder="Day"
                                            value={day}
                                            //onChange={(e) => setDay(e.target.value)}
                                             onChange={(e) => {
                                                const val = e.target.value;
                                                if (val === '') setDay('');
                                                else {
                                                const num = Math.min(Math.max(parseInt(val), 1), 31);
                                                setDay(num.toString());
                                                }
                                            }}
                                            min="1"
                                            max="31" />
                                        </div>
                                    </div>
                                    <div className="splitter-itm">
                                        <div className="form-input">
                                            <input  type="number" className="form-control"
                                            placeholder="Year"
                                            value={year}
                                            //onChange={(e) => setYear(e.target.value)} 
                                           onChange={(e) => {
                                                // Just update the raw text
                                                setYear(e.target.value);
                                            }}
                                            onBlur={(e) => {
                                                const val = e.target.value;
                                                if (val === '') return;
                                                const num = Math.min(Math.max(parseInt(val), 1900), 2200);
                                                setYear(num.toString());
                                            }}
                                            min="1900"
                                            max={new Date().getFullYear()}/>
                                        </div>
                                    </div>
                                </div>  
                                <div className="d-none">
                                <Datetime
                                    dateFormat="MM/DD/YYYY"
                                    inputProps={{
                                        onFocus: handleFocus,
                                        placeholder: 'e.g. 20/01/2025'
                                    }}
                                    timeFormat={false}
                                    open={isCalendarOpen}
                                    onChange={handleChange}
                                    value={foundedDate}
                                />
                                </div>
                                {foundedDate === "" && error ? (
                                    <Validation message={'Please enter founded date'} />
                                ) : null}
                                {dateError &&
                                    <Validation message={dateError} />}
                            </div>
                        </div>
                    </div>
                    <div className="edit-field">
                        <label className="edit-profile-label">Contact name</label>
                        <div className="edit-field-group">
                            <div className="form-group">
                                <input type="text" ref={contactNameRef} placeholder="Contact name" className="form-control" onChange={handleAcceptContactName} value={contactName}></input>
                                {contactName === "" && error ? (
                                    <Validation message={'Please enter contact name'} />
                                ) : null}
                                {contactName  && /\d/.test(contactName) ? (
                                    <Validation message={'Please enter a valid contact name'} />
                                ) : null}
                            </div>
                        </div>
                    </div>
                     <div className="edit-field">
                        <label className="edit-profile-label">Phone Number</label>
                        <div className="edit-field-group">
                           
                            <div className="form-group">
                               
                                <input type="text" className="form-control" maxLength={25} onChange={(e) => { setphoneNumber(e.target.value) }} value={phoneNumber}/>
                                   {phoneNumber === "" && error ? (
                                    <Validation message={'Please enter Cell'} />
                                ) : null}
                            </div>
                        </div>
                    </div>
                    <div className="edit-field">
                        <label className="edit-profile-label">Business Tax Id</label>
                        <div className="edit-field-group">
                           
                            <div className="form-group">
                               
                                <input type="text" className="form-control"
                                 onChange={handleAcceptNumeric}
                                 maxLength={25}
                                // onChange={(e) => { setTax(e.target.value) }} 
                                 value={taxId}/>
                                 {taxId === "" ? (
                                    <Validation message={'Please enter taxId'} />
                                ) : null}
                            </div>
                        </div>
                    </div>
                    <div className="edit-field">
                        <label className="edit-profile-label">Member Count</label>
                        <div className="edit-field-group">
                           
                            <div className="form-group">
                               
                                <input type="number" className="form-control" onChange={(e) => { setMemberCount(e.target.value) }} value={membercount}/>
                                 {membercount === "" && error ? (
                                    <Validation message={'Please enter member count'} />
                                ) : null}
                            </div>
                        </div>
                    </div>
                  
                      <div className="edit-field">
                        <label className="edit-profile-label">Website</label>
                        <div className="edit-field-group">
                           
                            <div className="form-group">
                               
                                <input type="text" className="form-control" onChange={(e) => { setwebsite(e.target.value) }} value={website}/>
                                   {website === "" && error ? (
                                    <Validation message={'Please enter Website'} />
                                ) : null}
                            </div>
                        </div>
                    </div>

                    <div className="edit-field">
                        <label className="edit-profile-label">Country</label>
                        <div className="edit-field-group">
                           
                            <div className="form-group">
                                <Form.Select /* className="form-control" */ aria-label="Default select example" onChange={(e) => { setCountry(e.target.value) }} value={country}>
                                    <option value=""></option>
                                    {Array.isArray(countryArr) &&
                                        countryArr.map((item) => (
                                            <option key={item._id} value={item._id}>{item.countryName}</option>
                                        ))}
                                </Form.Select>
                            </div>
                        </div>
                    </div>

                    {country === "681dde46519da80203bdf80f" &&
                        <>
                            <div className="edit-field">
                                <label className="edit-profile-label">Zip Code</label>
                                <div className="edit-field-group">
                                  
                                    <div className="form-group">
                                      <div className="form-group">
  <input
    type="text"
    inputMode="numeric" // improves UX on mobile
    placeholder="ZIP code"
    className="form-control"
    maxLength={5}
    pattern="\d{5}"
    value={zip}
    onChange={(e) => {
      const value = e.target.value.replace(/\D/g, '');
      if (value.length <= 5) {
        setZip(value);
      }
    }}
  />
  {zip && zip.length < 5 && (
    <Validation message="ZIP code must be exactly 5 digits" />
  )}
</div>

                                    </div>
                                </div>
                            </div>

                            <div className="edit-field">
                                <label className="edit-profile-label">Location</label>
                                <div className="edit-field-group">
                                   
                                    <div className="form-group">
                                        <input type="text" placeholder="Location" className="form-control" value={location} ></input>
                                    </div>
                                </div>
                            </div></>}
                            
                     


                    <div className="edit-field">
                        <label className="edit-profile-label">Description</label>
                        <div className="edit-field-group">
                           
                            <div className="form-group">
                                
                                <textarea className="form-control" onChange={(e) => { setBio(e.target.value) }} value={bio}></textarea>
                            </div>
                        </div>
                    </div>
                    {orgBasicQuestions?.map((question, qIndex) => {
                        let formattedOption = {}
                        if (question.questionControlType === "multiselect") {
                            formattedOption = question.answerOptions.map((item, index) => ({
                                name: item,
                                code: item,
                            }));
                        }

                        return (
                            <div className="edit-field bg-light p-2 rounded" key={question._id}>
                                <label className="edit-profile-label question">{question.question}</label>
                                <div className="edit-field-group">
                                    <div className="form-group position-relative">
                                        {question.questionControlType === "multichoice" && <Form.Select aria-label="Default select example"
                                            value={question?.answer?.[0]?.answer?.[0] || {}}
                                            onChange={(e) => handleIndividualQuestionChange(question._id, e.target.value)}


                                        >
                                            <option value="">Select...</option>
                                            {question.answerOptions.map((opt, index) => (
                                                <option value={opt}>{opt}</option>
                                            ))}
                                        </Form.Select>}
                                        {question.questionControlType === "textfield" &&
                                            <div className="radio-input">
                                                <Form.Group className="" >
                                                    <Form.Control as="textarea" rows={1}
                                                        value={question?.answer?.[0]?.answer?.[0] || ""}
                                                        onChange={(e) => {
                                                            const newValue = e.target.value;
                                                            const dataType = question.answerDataType;

                                                            // Simple per-type validation
                                                            let isValid = true;
                                                            if (dataType === "number") isValid = /^[0-9]*$/.test(newValue);
                                                            else if (dataType === "zipcode") isValid = /^[0-9]{0,5}$/.test(newValue);
                                                            else if (dataType === "string") isValid = /^[a-zA-Z\s.,'-]*$/.test(newValue);
                                                            if (!isValid) return;

                                                            handleIndividualQuestionChange(question._id, newValue);
                                                        }}
                                                    
                                                    />
                                                </Form.Group>
                                            </div>}
                                       

                                            {question.questionControlType === "date" && (() => {
                                            const existingDate = question?.answer?.[0]?.answer?.[0]
                                                ? moment(question.answer[0].answer[0]).format("MM/DD/YYYY")
                                                : "";

                                            // initialize refs for this specific question ID
                                            if (!monthRefs.current[question._id]) monthRefs.current[question._id] = "";
                                            if (!dayRefs.current[question._id]) dayRefs.current[question._id] = "";
                                            if (!yearRefs.current[question._id]) yearRefs.current[question._id] = "";

                                            if (existingDate && !monthRefs.current[question._id]) {
                                                const [m, d, y] = existingDate.split("/");
                                                monthRefs.current[question._id] = m;
                                                dayRefs.current[question._id] = d;
                                                yearRefs.current[question._id] = y;
                                            }

                                            const formatCustomDate = (m, d, y) => {
                                                if (!m || !d || !y) return "";
                                                return `${m.padStart(2, "0")}/${d.toString().padStart(2, "0")}/${y}`;
                                            };

                                            
                                            const updateDate = (newMonth, newDay, newYear) => {
                                            const formatted = formatCustomDate(newMonth, newDay, newYear);

                                            // --- ✅ Validate only when all fields are filled ---
                                            if (newMonth && newDay && newYear) {
                                                const parsedDate = new Date(formatted);

                                                const isValid =
                                                parsedDate instanceof Date &&
                                                !isNaN(parsedDate) &&
                                                parsedDate.getMonth() + 1 === parseInt(newMonth) &&
                                                parsedDate.getDate() === parseInt(newDay) &&
                                                parsedDate.getFullYear() === parseInt(newYear);

                                                if (isValid) {
                                                handleIndividualQuestionChange(question._id, formatted);
                                                } else {
                                                // invalid combination like 02/31/1990
                                                handleIndividualQuestionChange(question._id, "INVALID_DATE");
                                                }
                                            } else {
                                                // partial date (user still typing)
                                                handleIndividualQuestionChange(question._id, formatted);
                                            }

                                            forceRender((p) => p + 1);
                                            };


                                            return (
                                                <div className="dob-splitter">
                                                {/* Month Dropdown */}
                                                <div className="splitter-itm">
                                                    <div className="form-input">
                                                    <Form.Select
                                                        aria-label="Default select example"
                                                        value={monthRefs.current[question._id]}
                                                        onChange={(e) => {
                                                        monthRefs.current[question._id] = e.target.value;
                                                        updateDate(
                                                            monthRefs.current[question._id],
                                                            dayRefs.current[question._id],
                                                            yearRefs.current[question._id]
                                                        );
                                                        }}
                                                    >
                                                        {months.map((m) => (
                                                        <option key={m.value} value={m.value}>
                                                            {m.label}
                                                        </option>
                                                        ))}
                                                    </Form.Select>
                                                    </div>
                                                </div>

                                                {/* Day Input */}
                                                <div className="splitter-itm">
                                                    <div className="form-input">
                                                    <input
                                                        // type="text"
                                                        // inputMode="numeric"
                                                        type="number"
                                                        placeholder="Day"
                                                        value={dayRefs.current[question._id]}
                                                        onChange={(e) => {
                                                        const val = e.target.value;
                                                        dayRefs.current[question._id] = val;
                                                        updateDate(
                                                            monthRefs.current[question._id],
                                                            val,
                                                            yearRefs.current[question._id]
                                                        );
                                                        }}
                                                        onBlur={(e) => {
                                                        const val = parseInt(e.target.value);
                                                        if (!val) return;
                                                        const clamped = Math.min(Math.max(val, 1), 31);
                                                        dayRefs.current[question._id] = clamped.toString();
                                                        updateDate(
                                                            monthRefs.current[question._id],
                                                            dayRefs.current[question._id],
                                                            yearRefs.current[question._id]
                                                        );
                                                        }}
                                                        className="form-control"
                                                        maxLength="2"
                                                        min="1"
                                                        max="31"
                                                        onKeyDown={(e) => {
  if (e.key === "0" && e.target.value === "") {
    e.preventDefault(); // prevent typing 0 as first digit
  }
}}
                                                    />
                                                    </div>
                                                </div>

                                                {/* Year Input */}
                                                <div className="splitter-itm">
                                                    <div className="form-input">
                                                    <input
                                                        // type="text"
                                                        // inputMode="numeric"
                                                        type="number"
                                                        placeholder="Year"
                                                        value={yearRefs.current[question._id]}
                                                        onChange={(e) => {
                                                        const val = e.target.value;
                                                        yearRefs.current[question._id] = val;
                                                        updateDate(
                                                            monthRefs.current[question._id],
                                                            dayRefs.current[question._id],
                                                            val
                                                        );
                                                        }}
                                                        onBlur={(e) => {
                                                        const val = parseInt(e.target.value);
                                                        if (!val) return;
                                                        const clamped = Math.min(Math.max(val, 1900), 2200);
                                                        yearRefs.current[question._id] = clamped.toString();
                                                        updateDate(
                                                            monthRefs.current[question._id],
                                                            dayRefs.current[question._id],
                                                            yearRefs.current[question._id]
                                                        );
                                                        }}
                                                        className="form-control"
                                                        maxLength="4"
                                                         min="1900"
                                                        max={new Date().getFullYear()}
                                                    />
                                                    </div>
                                                </div>
                                                </div>
                                            );
                                            })()}
{question?.answer?.[0]?.answer?.[0] === "INVALID_DATE" && (
  <Validation message={'Please enter a valid date '} />
)}
                                        {question.questionControlType === "multiselect" &&
                                            <div className="radio-input">
                                                <MultiSelect
                                                    optionLabel="name"
                                                    options={formattedOption} // e.g., [{ name: "Hormone Therapy", code: "Hormone Therapy" }]
                                                    value={
                                                        Array.isArray(question?.answer?.[0]?.answer)
                                                            ? formattedOption.filter(opt => question.answer[0].answer.includes(opt.code))
                                                            : []
                                                    }
                                                    placeholder="Choose..."
                                                    maxSelectedLabels={1}
                                                    className=""
                                                    showSelectAll
                                                    panelHeaderTemplate={panelHeaderTemplate}

                                                    onChange={(e) => {
                                                        const selectedValues = e.value.map(item => item.code);
                                                        handleIndividualQuestionChange(question._id, selectedValues);
                                                    }}

                                                />


                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        )
                    })}

                 

                  <div className="main-action-buttons">
                        <button className="act-buttons bg-light text-dark" onClick={() => navigate('/organization')}>Cancel</button>
                        <button className="act-buttons" onClick={() => updateProfileDetails()}>Update</button>
                    </div>
                    <div className="delete-acc pb-5">
                        <button onClick={(e) => { e.preventDefault(); setIsDeleteAccount(true) }}>Delete Account ?

                        </button>
                    </div>



                </div>
            </div>
            {isEditEmail && <EditEmail isEditEmail={isEditEmail} handleClose={handleEditEmailClose} onSuccess={handleEmailSuccess} />}
           {isDeleteAccount && <DeleteAccount isLeaveCommunity={isDeleteAccount} handleClose={handleDeleteAccountClose} />}
            {isSucess && (<ResponsePopup
                isSucess={isSucess}
                CancelPopup={() => {
                    SetSucess(false);
                }}
                message={ResponseMessage}
            />)}
        </div>
    );

};
export default EditOrganization;